import type { LinkDetail } from '@/components/shared/link-widget'

// Use Web 2.0 URLs
export const CONCERT_CATEGORY_LINKS: LinkDetail[] = [
    { url: '/concerts/adult-contemporary', label: 'Adult Contemporary' },
    { url: '/concerts/alternative', label: 'Alternative' },
    { url: '/concerts/blues-jazz', label: 'Blues and Jazz' },
    { url: '/concerts/classical', label: 'Classical' },
    { url: '/concerts/country-folk', label: 'Country and Folk' },
    { url: '/concerts/dance-electronica', label: 'Dance/Electronica' },
    { url: '/concerts/hard-rock', label: 'Hard Rock' },
    { url: '/concerts/latin-music', label: 'Latin Music' },
    { url: '/concerts/festivals', label: 'Music Festivals' },
    { url: '/concerts/newage', label: 'New Age' },
    { url: '/concerts/pop', label: 'Pop' },
    { url: '/concerts/rb', label: 'R & B' },
    { url: '/concerts/rap-hiphop', label: 'Rap/Hip Hop' },
    { url: '/concerts/reggae', label: 'Reggae' },
    { url: '/concerts/rock', label: 'Rock' },
    { url: '/concerts/world-music', label: 'World Music' },
]

// Use Web 2.0 URLs
export const CONCERT_TICKETS_BY_CITY_LINKS: LinkDetail[] = [
    { url: '/region/usa/ga/atlanta-tickets/80/concerts', label: 'Atlanta Concerts' },
    { url: '/region/usa/ma/boston-area-tickets/74/concerts', label: 'Boston Concerts' },
    { url: '/region/usa/il/chicago-area-tickets/57/concerts', label: 'Chicago Concerts' },
    { url: '/region/usa/tx/dallas-tickets/19/concerts', label: 'Dallas Concerts' },
    { url: '/region/usa/tx/houston-tickets/18/concerts', label: 'Houston Concerts' },
    { url: '/region/usa/ca/los-angeles-tickets/29/concerts', label: 'Los Angeles Concerts' },
    { url: '/region/usa/ny/new-york-tickets/7/concerts', label: 'New York Concerts' },
    { url: '/region/usa/wa/seattle-tickets/26/concerts', label: 'Seattle Concerts' },
    { url: '/region/usa/ca/bay-area-tickets/28/concerts', label: 'SF Bay Area Concerts' },
    { url: '/region/usa/fl/south-florida-tickets/75/concerts', label: 'South Florida Concerts' },
    { url: '/region', label: 'All Regions' },
]
